import { gql } from 'graphql-request';
import gqlRequest from 'graphql/generic';

import { SignatureType } from '../services/types';

type GetSignatureReturn = {
  getSignatures: SignatureType[]
};

type GetSignatureParams = {orderId: string };

const query = gql`
query GetSignatures($orderId: ID!) {
	getSignatures(order_id: $orderId) {
	  _id
		timestamp
		embedded
		error
		file_description
		has_error
		is_complete
		is_declined
		signed_path
		download
		signers {
			name,
			order
			email
			error
			sign_url_error
			sign_url
			status
		}
	}
  }
`;

export const getSignatures = (id: string) => gqlRequest<GetSignatureReturn, GetSignatureParams>(query, { orderId: id });

export default {};
